import { PHOEBE_MARK_PATH } from '@apps/web/components/ui/phoebe_mark';

/**
 * The Phoebe mark, as a nav icon.
 *
 * Inlined rather than served from `/phoebe.svg` so it takes `currentColor` and
 * follows the nav's active and hover states like every lucide icon beside it.
 */
export function PhoebeFlowerIcon({
    className,
}: {
    readonly className?: string;
}) {
    return (
        <svg
            className={className}
            viewBox="35 35 108 108"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path d={PHOEBE_MARK_PATH} />
        </svg>
    );
}
